import React, { useEffect, useState } from "react";
import styles from "./FacturesFER.scss"
import { useAppText } from "src/commun/composants/AppText";
import AppCol from "src/commun/composants/grille/AppCol";
import { downloadFacture, getFactures, getPaymentLink, updatePaymentStatus } from "src/app/api/FacturesApi";
import {Facture} from "src/domain/Facture";
import AppIcon from "src/commun/composants/AppIcon";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import AppRow from "src/commun/composants/grille/AppRow";

export type FacturesFerProps = {
  factureId: number | undefined | null;
}

const FacturesFer = ({ factureId }: FacturesFerProps) => {
  const { tString } = useAppText();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [factures, setFactures] = useState<Facture[]>([]);

  useEffect(() => {
    if (factureId) {
      updatePaymentStatus(factureId).then(() => {
        getFactures().then(facturesRes => {
          setFactures(facturesRes);
        }).finally(() => setLoading(false));
      });
    } else {
      getFactures().then(facturesRes => {
        setFactures(facturesRes);
      }).finally(() => setLoading(false));
    }
  }, [factureId])

  const renderHead = () => {
    return (
      <tr>
        <th>{tString("factures.column.date")}</th>
        <th>{tString("factures.column.libelle")}</th>
        <th>{tString("factures.column.montant")}</th>
        <th>{tString("factures.column.originalFilename")}</th>
        <th>{tString("factures.column.statut")}</th>
        <th>{tString("factures.column.download")}</th>
        <th>{tString("factures.column.lienPaiement")}</th>
      </tr>
    )
  }

  const renderLine = (facture: Facture, index: number) => {
    return (
      <tr key={"facture" + index} className={`${!facture.dateTelechargement && styles.nonLu}`}>
        <td>{facture.date}</td>
        <td>{facture.libelle}</td>
        <td>{facture.montant}</td>
        <td>{facture.originalFilename}</td>
        <td>
          {facture.statut === "PAYE" && <span className={styles.paye}>{tString("factures.statut.paye")}</span>}
          {facture.statut === "A_PAYER" && <span className={styles.aPayer}>{tString("factures.statut.aPayer")}</span>}
          {facture.statut === "EXPIRE" && <span>{tString("factures.statut.expire")}</span>}
        </td>
        <td>
          <AppIcon
            name="tlcharger"
            className={styles.iconCursor}
            active
            size="38px"
            onClick={() => {
              setError(null);
              downloadFacture(facture.id)
                .catch(err => setError(err));
            }}
          />
        </td>
        {facture.statut === "A_PAYER" && facture.type === "RENOUVELLEMENT" ?
          <td>
            <AppIcon
              name="credit-card"
              className={`${styles.iconCursor}`}
              active
              size="28px"
              onClick={() => {
                setError(null);
                getPaymentLink(facture.id)
                  .then(res => {
                    window.open(res.paymentLink, "_self", "noopener");
                  })
                  .catch(err => setError(err));
              }}
            />
          </td>
          : <td></td>
        }
      </tr>
    )
  }

  if (loading) {
    return <AppSpinner animation="grow"/>;
  }

  return (
    <span className={`ferge-class`}>
      <AppRow>
        <AppCol md>
          <div className={`${styles.container} ${styles.factures}`}>
            <h2 className="appTitle">{tString("factures.title")}</h2>

            {error && <AppMessage messageType="ERROR" children={<>{tString("error.technical")}</>}/>}

            {(!factures || factures.length === 0) ?
              <AppMessage messageType="INFO" children={<>{tString("factures.info.pasDeFactures")}</>}/>
              :
              (
                <div className={styles.tableFacturesContainer}>
                  <table className={styles.tableFactures}>
                    <thead>
                      {renderHead()}
                    </thead>
                    <tbody>
                      {factures.map((facture, index) => renderLine(facture, index))}
                    </tbody>
                  </table>
                </div>
              )
            }
          </div>
        </AppCol>
      </AppRow>
    </span>
  );
};

export default FacturesFer;